import { render, staticRenderFns } from "./recentProjectList.vue?vue&type=template&id=ae11ffde&"
import script from "./recentProjectList.vue?vue&type=script&lang=js&"
export * from "./recentProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports